/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductListRetailerAssignment } from './ProductListRetailerAssignment';
// @ts-ignore
import {
// @ts-ignore
    ProductListRetailerAssignmentFromJSON,
// @ts-ignore
    ProductListRetailerAssignmentFromJSONTyped,
// @ts-ignore
    ProductListRetailerAssignmentToJSON,
} from './ProductListRetailerAssignment';

/**
 * 
 * @export
 * @interface ProductListRetailerAssignmentListResponse
 */
export interface ProductListRetailerAssignmentListResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductListRetailerAssignmentListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListRetailerAssignmentListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<ProductListRetailerAssignment>}
     * @memberof ProductListRetailerAssignmentListResponse
     */
    items: Array<ProductListRetailerAssignment>;
}

/**
 * Check if a given object implements the ProductListRetailerAssignmentListResponse interface.
 */
// @ts-ignore
export function instanceOfProductListRetailerAssignmentListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListRetailerAssignmentListResponseFromJSON(json: any): ProductListRetailerAssignmentListResponse {
    return ProductListRetailerAssignmentListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListRetailerAssignmentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListRetailerAssignmentListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(ProductListRetailerAssignmentFromJSON)),
    };
}

// @ts-ignore
export function ProductListRetailerAssignmentListResponseToJSON(value?: ProductListRetailerAssignmentListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(ProductListRetailerAssignmentToJSON)),
    };
}

